<template>
  <PageLayout class="knowledge-base-page">
    <PageTitle class="page-title">База знань</PageTitle>
    <KnowledgeBaseArticle />
  </PageLayout>
</template>

<script>
import { mapActions } from 'vuex';
import KnowledgeBaseArticle from '../../views/knowledge-base/show.vue';
import { pages } from '@/entities/current-page';
import { PageLayout } from '@/shared/ui/layouts';
import { PageTitle } from '@/shared/ui/page-title';

export default {
  created() {
    this.changeActivePage(pages.RESOURCES);
  },
  components: { PageLayout, PageTitle, KnowledgeBaseArticle },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
  },
};
</script>

<style lang="scss" scoped>
.page-title {
  font-size: 30px;
  line-height: 44px;
  color: #24282c;
  font-weight: 700;
  margin-bottom: 26px !important;
}

::v-deep button {
  text-align: center;
}

::v-deep input {
    border: 1px solid #dde2e5 !important;
    border-radius: 3px !important;

    &:hover {
        border-color: #ffad3d !important;
    }
}

::v-deep .multiselect__input {
    border: none !important;
}
</style>
